import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useThree } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import * as THREE from "three";

const CameraController = ({
  zoom,
  setZoom,
  isNeeded,
  controlsRef
}) => {
  
  const { camera } = useThree();
  const dispatch = useDispatch();
  // const controlsRef = useRef();
  const [isPanning, setIsPanning] = useState(false);
  const designStep = useSelector((state) => state.ApplicationState.designStep);
  const selectionMode = useSelector((state) => state.ApplicationState.selectionMode);
  const activeRoomButton = useSelector((state) => state.ApplicationState.activeRoomButton);

  
  const tutorialActive = useSelector((state) => state.ApplicationState.tutorialActive);

  // Prevent context menu on right-click
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
    window.addEventListener("contextmenu", handleContextMenu);
    return () => window.removeEventListener("contextmenu", handleContextMenu);
  }, []);

  useEffect(() => {
    if (Object.keys(window.cameraContext).length === 0) {
      window.cameraContext = camera;
    }
  }, [camera, dispatch]);

  useEffect(() => {
    if (controlsRef.current) {
      const controls = controlsRef.current;
      const handleChange = () => {
        const newContext = camera.clone();
        window.cameraContext = newContext;
      };

      controls.addEventListener("change", handleChange);

      return () => {
        controls.removeEventListener("change", handleChange);
      };
    }
  }, [camera, dispatch]);

  useEffect(() => {
    if (isNeeded) {
      camera.zoom = zoom;
      camera.updateProjectionMatrix();
    }
    const newContext = camera.clone();
    window.cameraContext = newContext;
  }, [zoom, camera, dispatch]);

  const handleControlsChange = () => {
    setZoom(camera.zoom, false);
  };

  const handleStart = () => {
    setIsPanning(true);
  };

  const handleEnd = () => {
    setIsPanning(false);
  };

  return (
    <OrbitControls
      ref={controlsRef}
      enableRotate={false}
      // enablePan={false}
      enablePan={selectionMode && designStep !== 1 && !(activeRoomButton=="divide" | activeRoomButton=="add")}
      enableZoom={tutorialActive ? false: true}
      minZoom={0.3}
      maxZoom={4.5}
      // minPan={new THREE.Vector3(-100 * camera.zoom, -100 * camera.zoom, 0)}
      // maxPan={new THREE.Vector3(100 * camera.zoom, 100 * camera.zoom, 0)}
      onChange={handleControlsChange}
      maxAzimuthAngle={Math.PI / 100}
      minAzimuthAngle={-Math.PI / 100}
      maxPolarAngle={Math.PI / 2}
      minPolarAngle={Math.PI / 2}
      zoomToCursor={true}
      onStart={handleStart}
      onEnd={handleEnd}
      mouseButtons={{
        LEFT: null,
        MIDDLE: null,
        RIGHT: selectionMode ? THREE.MOUSE.PAN : null,
        // RIGHT: null
      }}
    />
  );
};

export default CameraController;
